export const prefixTarget = (target, groups) => {
  if (!(groups || []).map(group => group.id).includes(target)) return target
  return `group: ${target}`
}
